import request from '@/utils/request';

export async function mockUser(params: { name: string }) {
  return request('/api/debug/mock-user', {
    method: 'POST',
    data: params,
  });
}
